module.exports = __webpack_public_path__ + "media/images/lp_v6_arw2-5dbebcccea1cccf18f0dbda1b95dc905.webp";